import { render, staticRenderFns } from "./AssociationList.vue?vue&type=template&id=3e7ae1ae&"
import script from "./AssociationList.vue?vue&type=script&lang=js&"
export * from "./AssociationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports